<nav>

	<div class="nav-group" ngbDropdown container="body" placement="right-top">
		<a data-testid="SUBSYS5_SIDEBAR_MENU_TOGGLE" class="nav-link" href="" onclick="return false" ngbDropdownToggle>
			<span class="material-icons">account_circle</span>
		</a>
		<div class="dropdown-menu" ngbDropdownMenu>
			<a data-testid="SUBSYS5_SIDEBAR_MENU_ABOUT" href="" onclick="return false;" class="dropdown-item text-truncate"
				[title]="labels().SIDEBAR_COMPONENT_ABOUT" (click)="openAboutPage()">
				{{ labels().SIDEBAR_COMPONENT_ABOUT }}
			</a>
			<a data-testid="SUBSYS5_SIDEBAR_MENU_COOKIE" href="" onclick="return false;" class="dropdown-item text-truncate"
				[title]="labels().SIDEBAR_COMPONENT_COOKIE" (click)="openCookieModal()">
				{{ labels().SIDEBAR_COMPONENT_COOKIE }}
			</a>
			@if (envName != 'production') {
			<div data-testid="SUBSYS5_SIDEBAR_MENU_VERSION" class="simple-text">{{ buildVersion }}</div>
			}
			<a data-testid="SUBSYS5_SIDEBAR_MENU_LOGOUT" href="" onclick="return false;" class="dropdown-item text-truncate"
				[title]="labels().SIDEBAR_COMPONENT_LOGOUT" (click)="logout()">
				{{ labels().SIDEBAR_COMPONENT_LOGOUT }}
			</a>
		</div>
	</div>

	<div class="nav-group" style="bottom: 50%;">
		<a data-testid="SUBSYS5_SIDEBAR_DASHBOARD_BTN" href="" onclick="return false" class="nav-link"
			[routerLink]="PAGE.DASHBOARD" routerLinkActive="active" [title]="labels().SIDEBAR_COMPONENT_DASHBOARD_BTN">
			<i class="material-icons-outlined">dashboard</i>
		</a>
		<a data-testid="SUBSYS5_SIDEBAR_LIST_BTN" href="" onclick="return false" class="nav-link"
			[routerLink]="PAGE.PATIENT_LIST" routerLinkActive="active" [title]="labels().SIDEBAR_COMPONENT_LIST_BTN">
			<i class="material-icons">format_list_bulleted</i>
		</a>
	</div>

</nav>